<app-header [navbarBrandRouterLink]="['/dashboard']" [fixed]="true"
  [navbarBrandFull]="{src: appLogo, width: 75, height: 50, alt: appName}"
  [navbarBrandMinimized]="{src: appLogo, width: 60, height: 40, alt: appName}"
  [sidebarToggler]="'lg'" [asideMenuToggler]="'lg'">
  <ul class="nav navbar-nav ml-auto">
    <span>{{profile.name}}</span>
    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
        dropdownToggle (click)="false">
        <img [src]="profile.photo" (error)="updateUrl()"
          class="img-avatar border" />
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong>Settings</strong></div>
        <a class="dropdown-item" [routerLink]="['/profile']"><i class="fa fa-user"></i> Profile</a>
        <!-- <a class="dropdown-item" href="#"><i class="fa fa-wrench"></i> Setting</a> -->
        <a class="dropdown-item pointer" (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
      </div>
    </li>
  </ul>
</app-header>
<div class="app-body">
  <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized"
    (minimizedChange)="toggleMinimize($event)">
    <app-sidebar-nav [navItems]="navItems"></app-sidebar-nav>
    <app-sidebar-minimizer></app-sidebar-minimizer>
  </app-sidebar>
  <!-- Main content -->
  <main class="main">
    <cui-breadcrumb>
      <span class="ml-auto">{{time | date:'medium'}}</span>
    </cui-breadcrumb>
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
<app-footer>
  <span><a href="https://xrossoversports.com">XrossOver Sports</a> &copy; {{currentYear}}</span>
</app-footer>